import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAnalytics from "./hooks/useAnalytics";

const AnalyticsWrapper = ({ children }) => {
  useAnalytics(); // inicializa y trackea pageviews
  return children;
};

export default AnalyticsWrapper;
